import Api from './Api'
import {handleError} from '../util/ApiErrorUtil'

const omitEmptyParams = params => Object.keys(params || {}).reduce((acc, key) => {
    const value = params[key];

    if (!value || (Array.isArray(value) && value.length === 0)) {
        return acc;
    }

    acc[key] = value;
    return acc;
}, {});

class User {
    static list(params = {}) {
        return new Promise((resolve, reject) => {
            return Api.get(`/users`, null, omitEmptyParams(params)).then(response => {
                resolve(response)
            }).catch((err) => {
                reject(handleError(err))
            })
        })
    }

    static search(q, field) {
        return new Promise((resolve, reject) => {
            return Api.get(`/users/search`, null, omitEmptyParams({ q, field })).then(response => {
                resolve(response)
            }).catch((err) => {
                reject(handleError(err))
            })
        })
    }

    static create(data) {
        return new Promise((resolve, reject) => {
            return Api.post(`/users`,data).then(response => {
                resolve(response)
            }).catch((err) => {
                reject(handleError(err))
            })
        })
    }

    static remove(id) {
        return new Promise((resolve, reject) => {
            return Api.delete(`/users/${id}`).then(response => {
                resolve(response)
            }).catch((err) => {
                reject(handleError(err))
            })
        })
    }

    static update(user) {
        return new Promise((resolve, reject) => {
            return Api.put(`/users/${user._id}`, user).then(response => {
                resolve(response)
            }).catch((err) => {
                reject(handleError(err))
            })
        })
    }
}

export default User
